import type { MouseEvent, ReactNode } from "react";

interface QuestionProps {
  q: string;
  description?: string;
  children: ReactNode;
}

export const Question = ({ q, description, children }: QuestionProps) => {
  const ignoreSpanClicks = (e: MouseEvent<HTMLSpanElement>) =>
    e.preventDefault();

  return (
    <label className="flex flex-col gap-2">
      <span
        className="font-semibold text-base text-gray-800"
        onClick={ignoreSpanClicks}
      >
        {q}
      </span>
      {description && (
        <span
          className="text-gray-500 text-sm leading-5"
          onClick={ignoreSpanClicks}
        >
          {description}
        </span>
      )}
      {children}
    </label>
  );
};
